import { Directive, ElementRef, HostListener, Input } from '@angular/core';


@Directive( {
  // tslint:disable-next-line:directive-selector
  selector: '[onlyNumbers]'
} )
export class OnlyNumbersDirective {

  @Input() maxlength: number;
  @Input() decimals = null;

  private pattern = /^[0-9]*$/;

  constructor( private el: ElementRef ) {


  }

  @HostListener( 'keydown', ['$event'] ) onKeyDown( event ) {

    const e = event as KeyboardEvent;

    if ( [46, 8, 9, 27, 13].indexOf( e.keyCode ) !== -1 ||
      // Allow: Ctrl+A
      ( e.keyCode === 65 && ( e.ctrlKey || e.metaKey ) ) ||
      // Allow: Ctrl+C
      ( e.keyCode === 67 && ( e.ctrlKey || e.metaKey ) ) ||
      // Allow: Ctrl+V
      ( e.keyCode === 86 && ( e.ctrlKey || e.metaKey ) ) ||
      // Allow: Ctrl+X
      ( e.keyCode === 88 && ( e.ctrlKey || e.metaKey ) ) ||
      // Allow: home, end, left, right
      ( e.keyCode >= 35 && e.keyCode <= 39 ) ) {
      // let it happen, don't do anything
      return;
    }
    // @ts-ignore
    if ( this.decimals ) {
      // @ts-ignore
      if ( e.keyCode === 110 && e.target.value.indexOf( '.' ) > 0 ) {
        e.preventDefault();
      }

      // @ts-ignore
      if ( e.target.value.indexOf( '.' ) > -1 && !( e.shiftKey
        || ( e.keyCode < 48 || e.keyCode > 57 ) ) && ( e.keyCode < 96 || e.keyCode > 105 ) ) {
        e.preventDefault();
        return;
      }
      // @ts-ignore
      const decimal = this.decimals;
      // @ts-ignore
      if ( e.target.value.indexOf( '.' ) !== -1 && e.target.value.substring( e.target.value.indexOf( '.' ) + 1 ).length >= decimal ) {

        e.preventDefault();
        return;
      }
      if ( e.keyCode !== 110 && ( e.shiftKey || ( e.keyCode < 48 || e.keyCode > 57 ) ) && ( e.keyCode < 96 || e.keyCode > 105 ) ) {
        e.preventDefault();
      }
    } else {
      if ( ( e.shiftKey || ( e.keyCode < 48 || e.keyCode > 57 ) ) && ( e.keyCode < 96 || e.keyCode > 105 ) ) {
        e.preventDefault();
      }
    }
  }

  @HostListener( 'paste', ['$event'] ) blockPaste( event: KeyboardEvent ): void {
    setTimeout( () => {
      this.el.nativeElement.value = AccountsUtil.filterNumbers( this.el.nativeElement.value );
    }, 1 );
  }


}

export class AccountsUtil {

  static addDecimals( n: number | string ): string {
    try {
      const arr = n.toString().split( '.' );
      if ( arr.length === 1 ) {
        arr.push( '00' );
      } else {
        if ( arr[ 1 ].length === 1 ) {
          arr[ 1 ] = `${arr[ 1 ]}0`;
        }
      }
      return arr.join( '' );
    } catch ( e ) {
      console.log( 'addDecimals', e );
      return n.toString();
    }
  }


  static filterNumbers( value: string ) {
    const pattern = /^[0-9]*$/;
    if ( value && typeof value === 'string' ) {
      const arr = [];
      value.split( '' ).forEach( n => {
        if ( pattern.test( n ) ) {
          arr.push( n );
        }
      } );
      return arr.join( '' );
    } else {
      return value;
    }
  }

}
